import { renderSlot as _renderSlot, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _mergeProps({
    class: ['go-vin-btn', _ctx.type, _ctx.outline && 'outline-white']
  }, _toHandlers(_ctx.$listeners, true)), [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 16))
}